// SPDX-FileCopyrightText: 2024 Comcast
//
// SPDX-License-Identifier: LicenseRef-Comcast

export class CloseChatBase {
  chatId: string;
  isAsyncAutoClose?: boolean;
  isAsyncPauseAbandoned?: boolean;
}
